import React, { type ReactNode } from 'react';
import { ProfileDropdown } from '@/components/ProfileDropdown';
import { tv } from '@/utils/tv';

const shadow = tv({
  base: 'pointer-events-none absolute inset-0 shadow-header transition-opacity duration-300',
  variants: {
    hasShadow: {
      true: 'opacity-40',
      false: 'opacity-0',
    },
  },
});

interface Props {
  hasShadow?: boolean;
  hideOnMobile?: boolean;
  desktopHeader?: ReactNode;
  mobileHeader?: ReactNode;
}

export const Header: React.FC<Props> = ({
  hasShadow = false,
  hideOnMobile = false,
  desktopHeader,
  mobileHeader,
}) => (
  <header
    className={`relative z-20 flex shrink-0 flex-col gap-6 bg-background px-4 pt-3 pb-4 md:h-[70px] md:flex-row md:items-center md:justify-between md:gap-6 md:bg-card md:px-6 md:py-0 ${hideOnMobile ? 'max-md:hidden' : ''}`}
  >
    <span aria-hidden className={shadow({ hasShadow })} />

    <div className="flex min-w-0 items-center justify-between gap-6 md:flex-1">
      <div className="hidden min-w-0 items-center gap-3 md:flex md:w-auto md:shrink-0">
        {desktopHeader}
      </div>
      <div className="flex w-full min-w-0 md:hidden">
        {mobileHeader ?? <ProfileDropdown />}
      </div>
      <div className="hidden min-w-0 md:flex md:flex-1 md:justify-end">
        <ProfileDropdown />
      </div>
    </div>
  </header>
);
